module.exports = __webpack_public_path__ + "img/smell-1.e4b0fc38.svg";